module.exports = __webpack_public_path__ + "static/media/png.64be7207.svg";